export default __webpack_public_path__ + "static/media/Mark-2-HUD-Altitude Range.b9496e4a.jpg";